import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

import { Input } from '@vds/inputs';

const EmailInput = (props) => {
  const [inputStatus, setInputStatus] = useState({
    success: false,
    error: false,
    errorText: '',
    preEmail: '',
  });

  const { valid = '', maxAttempts = false } = props.isValidEmail || {};

  useEffect(() => {
    const validateStatus = {
      success: false,
      error: true,
      errorText: '',
      fromHandleError: true,
    };
    if (valid === 'false' || valid === 'Manual_validation' || valid === 'Invalid' || valid === 'Fake') {
      if (maxAttempts) {
        validateStatus.errorText = "You've changed your email address too many times. Please try again later.";
      } else if (valid === 'false' || valid === 'Invalid' || valid === 'Fake') {
        validateStatus.errorText = 'Please enter a valid email address.';
      }
      setInputStatus({ ...validateStatus });
    } else if (valid === 'true' || valid === 'Valid' || valid === 'White_listed') {
      setInputStatus({ ...validateStatus, success: true, error: false });
    }
  }, [valid, maxAttempts]);

  const handleError = (e, id = null, noBlurFlag = false) => {
    const validateStatus = {
      success: false,
      error: false,
      errorText: '',
      fromHandleError: true,
    };
    const pattern = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
    if (e.target.value === '') {
      inputStatus.error = true;
      inputStatus.errorText = 'You must enter a email address';
      if (e.type === 'focus' || e.type === 'keyup') {
        inputStatus.error = false;
        inputStatus.errorText = '';
      }
    } else if (pattern.test(e.target.value.trim())) {
      if (e.type === 'blur' || noBlurFlag) {
        if (props.emailAPICall === null) {
          inputStatus.error = true;
          inputStatus.errorText = "You've changed your email address too many times. Please try again later.";
        } else if (props.emailAPICall !== null) {
          if (inputStatus.preEmail !== e.target.value.trim()) {
            if (props.pageName === 'shippingInfo' || props.pageName === 'appointment') {
              if (props.existEmail === e.target.value && props.setEmailValidationdata) {
                props.setEmailValidationdata({
                  valid: 'Valid',
                  serviceAvailable: 'false',
                });
              } else {
                setInputStatus({ ...inputStatus, validateStatus, preEmail: e.target.value });
                props.emailAPICall(e.target.value, id);
              }
            } else {
              setInputStatus({ ...inputStatus, validateStatus, preEmail: e.target.value });
              props.emailAPICall(e.target.value, id);
            }
          }
        }
        if (props.pageName !== 'contactinfo') {
          inputStatus.success = true;
        }
      }
    } else {
      inputStatus.error = true;
      if (props.pageName !== 'contactinfo') {
        inputStatus.errorText = 'Please enter a valid email address.';
      } else {
        inputStatus.fromHandleError = false;
      }
    }
    setInputStatus({ ...inputStatus, validateStatus });
  };

  const debounceHandleError = (e) => {
    handleError(e, props.id, true);
  };

  const delayedEmailValidation = useCallback(debounce(debounceHandleError, 700), []);

  const onChangeHandler = (e) => {
    props.onChange(e);
    delayedEmailValidation(e);
  };

  const toggleProps = props.hideBlurFlag
    ? { onChange: onChangeHandler }
    : {
        onChange: props.onChange,
        onBlur: (e) => handleError(e, props.id),
        onKeyDown: (e) => handleError(e),
        onKeyUp: (e) => handleError(e),
      };

  return (
    <Input
      type={props.type}
      // onBlur={(e) => this.handleError(e, props.id)}
      // onKeyDown={(e) => this.handleError(e)}
      // onKeyUp={(e) => this.handleError(e)}
      label={props.label}
      ariaLabel={props.ariaLabel}
      data-analyticstrack={props.analyticstrack}
      disabled={props.isDisabled}
      error={inputStatus.fromHandleError ? inputStatus.error : props.error}
      errorText={inputStatus.fromHandleError ? inputStatus.errorText : props.errorText}
      success={props.success && props.value && !inputStatus.error}
      inputId={props.id}
      width={props.width}
      defaultValue={props.defaultValue}
      placeholder={props.placeholder}
      maxLength={props.maxLength}
      tooltipContent={props.tooltipContent}
      helperText={props.helperText}
      helperTextPlacement={props.helperTextPlacement}
      // optional={props.optional}
      // onChange={props.onChange}
      value={props.value}
      successText={props.successText}
      autocomplete="off"
      {...toggleProps}
    />
  );
};

// Input.defaultProps = {
//   disabled: false,
//   error: false,
//   errorText: '',
//   success: false,
//   successText: '',
//   hideBlurFlag: false,
// };

EmailInput.defaultProps = {
  isDisabled: false,
  error: false,
  errorText: '',
  success: false,
  successText: '',
  hideBlurFlag: false,
};

EmailInput.propTypes = {
  defaultValue: PropTypes.string,
  placeholder: PropTypes.any,
  maxLength: PropTypes.any,
  tooltipContent: PropTypes.string,
  helperText: PropTypes.string,
  // optional: PropTypes.any,
  type: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  analyticstrack: PropTypes.string,
  isDisabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  width: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  errorText: PropTypes.string,
  error: PropTypes.bool,
  emailAPICall: PropTypes.func,
  isValidEmail: PropTypes.any,
  pageName: PropTypes.string,
  existEmail: PropTypes.string,
  setEmailValidationdata: PropTypes.func,
  success: PropTypes.bool,
  successText: PropTypes.string,
  hideBlurFlag: PropTypes.bool,
  helperTextPlacement: PropTypes.string,
};

export default React.memo(EmailInput);
